import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/_services/admin.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-protection-of-data-verify',
  templateUrl: './protection-of-data-verify.component.html',
  styleUrls: ['./protection-of-data-verify.component.css']
})
export class ProtectionOfDataVerifyComponent implements OnInit {
  isVerifyFound = false
  myFormVerification: FormGroup
  verificationCode=0
  isVerifying=false
  isCompleted =false
  yieldMessage=""
  id:number=0
  constructor(private activeRoute:ActivatedRoute, private adminService:AdminService) {

  }
  get f() { return this.myFormVerification.controls; }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(
      pp=>{
        this.id=+pp['id']
      }
    )
    this.initVerificationCodeFormFresh()
  }

  formatVerificationData(){
    let data = new URLSearchParams();
    data.set('id', this.id.toString());
    data.set('verificationCode',this.verificationCode.toString());
    return data.toString()
  }
  on_submitVerify(): void {
    // stop here if form is invalid
    if (this.myFormVerification.invalid) {
        return;
    }
    this.isVerifying = true;
    this.verificationCode=this.myFormVerification.value.verificationCode
    this.saveVerification()
  }

  saveVerification(){
    let dd = this.formatVerificationData()
    this.adminService.confirmAccountDelete(dd, this.id).subscribe(
    data=>{
      this.isVerifying=false
      this.manageVerifyResponse(data)
    })
  }
  manageVerifyResponse(data:any){

    this.isCompleted=true
    if(data['is_found']==1){
      this.isVerifyFound=true

      this.yieldMessage="Your account will be permanently deleted after 30 days"
      Swal.fire(this.yieldMessage)
    }else{
      this.yieldMessage="Sorry we cannot confirm the account deletion. You entered a wrong verification code"
      Swal.fire(this.yieldMessage)
    }
  }
  initVerificationCodeFormFresh(){
    this.myFormVerification=new FormGroup({
      verificationCode: new FormControl('', Validators.compose([Validators.required,  Validators.minLength(4)]))
    });
    }
}
